<template>
  <a-modal
    class="myModal fileDialog smallDialog"
    :visible="visible"
    :confirmLoading='confirmLoading'
    :title="title"
    v-drag-modal
    :destroyOnClose="true"
    :width="400"
    @cancel="handleCancel"
    >

    <template slot='footer'>
      <div class="btnsClass">
        <a-button type="link" @click="handleCancel" class="cancelBtn">取消</a-button>
        <a-button type="link" @click="handleOk" class="confirmBtn">确定</a-button>
      </div>
    </template>

    <a-divider class="divider"></a-divider>

    <a-form-model ref="form" :model='formModel' :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="文件夹名称" prop='dirName' required>
        <a-input v-model="formModel.dirName"></a-input>
      </a-form-model-item>
      <a-form-model-item label="父文件夹">
        <a-tree-select
          v-model="formModel.dirParentName"
          @change='change'
          allowClear
          :disabled='title == "编辑文件夹"'
          tree-default-expand-all
          style="width: 100%"
          :replaceFields='replaceFields'
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :treeData="dirData">
        </a-tree-select>
      </a-form-model-item>
    </a-form-model>

    <a-divider class="divider"></a-divider>

  </a-modal>
</template>

<script>
  // import { postHeadersAction_ds } from '../../../../api/manage'
  export default {
    name:'addDialog',
    data() {
      return {
        title:'添加文件夹',
        visible: false,
        confirmLoading: false,
        formModel:{
          dirName:'',
          dirParentName:''
        },
        labelCol: { span: 7 },
        wrapperCol: { span: 16 },
        dirData:[],
        replaceFields: {
          children: "children",
          title: "dirName",
          key: "bsm",
          value: "bsm",
        },
      }
    },
    // mounted () {
    //   console.log('mounted mounted mounted');
    //   this.$bus.$on('closeAddFileDialog',() => {
    //     console.log('$bus.$on  $bus.$on  $bus.$on');
    //     this.handleCancel()
    //   });
    // },
    // beforeDestroy () {
    //   console.log('beforeDestroy beforeDestroy beforeDestroy');
    //   this.$bus.$off('closeAddFileDialog');
    // },
    methods: {
      openDialog(info,type,fileArr){
        // console.log('新建文件夹',info,type,fileArr);
        var fileArr = JSON.parse(JSON.stringify(fileArr))
        this.dirData = []
        this.formModel = {dirName:'',dirParentName:''}
        this.dirData = fileArr.voList ? fileArr.voList : []
        this.dirData.unshift({dirName:'无',bsm:'0',children:[]})
        if(type == 'edit'){
          this.title = '编辑文件夹'
          this.formModel.bsm = info.bsm
          this.formModel.dirName = info.dirName
          this.formModel.dirParentId = info.dirParentId
          this.filterDir(this.dirData,info.dirParentId)
          this.formModel.dirParentName = this.formModel.dirParentName ? this.formModel.dirParentName : '无'
        }else{
          this.title = '添加文件夹'
          this.formModel.bsm = ''
          this.formModel.dirName = ''
          this.formModel.dirParentId = info.bsm
          this.formModel.dirParentName = info.dataName ? info.dataName : '无'
        }
        this.formModel.dirType = info.dirType
        this.formModel.dirTypeName = info.dirTypeName
        this.formModel.username = info.username
        this.visible = true
        this.$bus.$on('closeAddFileDialog',() => {
          this.handleCancel()
        });
      },
      // 根据节点id找到父文件夹名
      filterDir(data,id){
        data.map(item => {
          if(item.bsm == id){
            this.formModel.dirParentName = item.dirName
          }else if(item.children && item.children.length > 0){
            this.filterDir(item.children,id)
          }
        })
      },
      // 更改下拉框内容
      change(value,label,extra) {
        this.formModel.dirParentId = value ? value : 0
        this.formModel.dirParentName = label.length > 0 ? label[0] : '无'
      },
      /**
       * 保存
       */
      handleOk() {
        this.$refs.form.validate(valid => {
          if(valid){
            this.$emit('myCollectionHandleNode',this.title,this.formModel)
          }
        })
      },
      /**
       * 关闭弹框
       */
      handleCancel () {
        this.$bus.$off('closeAddFileDialog');
        this.visible = false
      }
    },
  }
</script>

<style lang="less" scoped>
.btnsClass{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
  .cancelBtn {
    color: rgba(255, 255, 255, 0.50);
  }
}
/deep/ .ant-modal-footer, /deep/ .ant-modal-body, /deep/ .ant-modal-header {
  border: 0 !important;
  background: transparent !important;
}
/deep/ .ant-modal-header {
  padding: 9px 13px;
}
/deep/ .ant-modal-body {
  padding: 0;
}
/deep/ .ant-modal-footer {
  padding: 3px 0;
}
/deep/ .ant-form-item {
  display: flex;
  margin-bottom: 5px;
}
/deep/ .ant-divider-horizontal {
    min-width: 94%;
    width: 94%;
    margin: auto !important;
}
.fileDialog /deep/ .ant-modal-title {
  font-size:16px
}
/deep/ .ant-modal-close-x {
  height: 40px;
  line-height: 40px;
  i {
    color: rgba(225,225,225,0.8);
  }
}
/deep/ .ant-form-horizontal {
  margin: 12px 0;
}
/deep/ .ant-input {
  border: 1px solid rgba(255, 255, 255, 0.50);
  background: 1px solid rgba(255, 255, 255, 0.10);
}
</style>